export default __webpack_public_path__ + "static/media/bgvideo.fe701c20.mp4";